module.exports = __webpack_public_path__ + "img/vertical_4_3_0.c90f808b.png";